// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"18ee177d","162":"7b8990c5","350":"3665bb07","373":"3665bb07","439":"f1c3bfcd","583":"fd091b0a","656":"1a4fa202","664":"081c969a","742":"f2a74f08","820":"7c179704","935":"29d63afe"}[chunkId] + ".chunk.css";
};